import _styled from "styled-components"; // biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import cn from 'classnames';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';
import { useResponsiveContext } from "../../context/Responsive";
import { jsx as _jsx } from "react/jsx-runtime";
var MiddleButton = function MiddleButton(_ref) {
  var className = _ref.className,
    style = _ref.style,
    icon = _ref.icon,
    onClick = _ref.onClick,
    disabled = _ref.disabled,
    ariaLabel = _ref['aria-label'];
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var buttonClassName = cn('button-base flex-shrink-0', disabled ? 'text-gray-main' : 'text-white', className);
  var size = icon.size || (playerSize.matches.xs ? 48 : 24);
  var Icon = icon.component;
  return /*#__PURE__*/_jsx(_StyledButton, {
    type: "button",
    onClick: onClick,
    disabled: disabled,
    className: buttonClassName,
    style: style,
    "aria-label": ariaLabel,
    $_css: size,
    $_css2: size,
    $_css3: size,
    $_css4: size,
    children: /*#__PURE__*/_jsx(Icon, {
      className: "fill-current flex-shrink-0",
      ignoreColor: true
    })
  });
};
export default MiddleButton;
var _StyledButton = /*#__PURE__*/_styled("button").withConfig({
  componentId: "sc-196kkjm-0"
})(["\n        width: ", "px;\n        height: ", "px;\n        & > svg {\n          width: ", "px;\n          height: ", "px;\n        }\n      "], function (p) {
  return p.$_css;
}, function (p) {
  return p.$_css2;
}, function (p) {
  return p.$_css3;
}, function (p) {
  return p.$_css4;
});